export default {
  currentUserAdmin: {
    id: null,
    name: null,
    email: null,
    image: null
  },
  currentUserEndUser: {
    id: null,
    name: null,
    email: null,
    image: null
  }
};
